// AI Generated Test
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

@Component({
    selector: 'table-select-item-all',
    standalone: false,
    templateUrl: './table-select-item-all.component.html',
})
export class TableSelectItemAllComponent implements OnInit {
    @Input() items: any[] = [];
    @Input() selectedItems: any[] = [];
    @Input() monLabel?: string;
    @Input() disable?: boolean = false;

    @Output() selectedItemsChange = new EventEmitter<any[]>();

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.monLabel = this.monLabel || this.translateService.getString('Select all items');
        this.items = this.items || [];
        this.selectedItems = this.selectedItems || [];
        this.disable = this.disable || false;
    }

    haveAllItems (): boolean {
        const filteredItems = this.selectedItems.filter(item => {
            return this.indexOfItem(this.items, item) > -1;
        });

        return filteredItems.length === this.items.length;
    }

    hasSomeItems (): boolean {
        if (this.haveAllItems()) {
            return false;
        }
        return this.items.some(item => {
            return this.indexOfItem(this.selectedItems, item) > -1;
        });
    }

    toggleItems (): void {
        if (!this.haveAllItems()) {
            this.items.forEach(item => {
                if (this.indexOfItem(this.selectedItems, item) === -1) {
                    this.selectedItems.push(item);
                }
            });
        } else {
            this.items.forEach(item => {
                const index = this.indexOfItem(this.selectedItems, item);
                if (index > -1) {
                    this.selectedItems.splice(index, 1);
                }
            });
        }
        this.selectedItemsChange.emit(this.selectedItems);
    }

    private indexOfItem (collection: any[], val: any): number {
        const stringified = this.stringify(val);
        for (let i = 0; i < collection.length; i++) {
            if (this.stringify(collection[i]) === stringified) {
                return i;
            }
        }
        return -1;
    }

    private stringify (val: any): string {
        return JSON.stringify(val, (key, value) => {
            let newVal = value;

            if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
                newVal = undefined;
            }

            return newVal;
        });
    }
}
